module.exports = __webpack_public_path__ + "static/media/sightnight-4.0c8e6899.jpg";